import { updateSessionWithResult } from "@iewc/Services/SessionService";
import { addToChainAfter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    getSession as getSessionApi,
    UpdateSessionWithResultApiParameter,
} from "@insite/client-framework/Services/SessionService";
import {
    chain,
    PopulateApiParameter,
    UpdateSession,
} from "@insite/client-framework/Store/Context/Handlers/ChangeCustomerContext";
import { BillToModel, ShipToModel } from "@insite/client-framework/Types/ApiModels";

addToChainAfter(chain, PopulateApiParameter, props => {
    if (!props.apiParameter.additionalQueryStringParameters) {
        props.apiParameter.additionalQueryStringParameters = {};
    }
    props.apiParameter.additionalQueryStringParameters.isContinue = true;
});

replaceInChain(chain, UpdateSession, async props => {
    const newApiParameter: UpdateSessionWithResultApiParameter = { ...props.apiParameter };
    if (props.apiParameter.session.billToId) {
        newApiParameter.session.billTo = {
            id: props.parameter.billToId,
            isDefault: props.parameter.isDefault,
        } as BillToModel;
    }
    if (props.apiParameter.session.shipToId !== undefined) {
        newApiParameter.session.shipTo = { id: props.parameter.shipToId } as ShipToModel;
    }

    const result = await updateSessionWithResult(newApiParameter);
    if (result.successful) {
        props.apiResult = await getSessionApi({});
    } else {
        props.parameter.onError?.(result.errorMessage);
        return false;
    }
});
